import { render } from "./HistorialCxc.vue?vue&type=template&id=1e32f2c5&scoped=true"
import script from "./HistorialCxc.vue?vue&type=script&lang=js"
export * from "./HistorialCxc.vue?vue&type=script&lang=js"

import "./HistorialCxc.vue?vue&type=style&index=0&id=1e32f2c5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e32f2c5"]])

export default __exports__